import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const GeoPhone = ({ variant = "icon" }) => {
    const [phone, setPhone] = useState("+91-124-4807600");
    const [fixcountry, setfixcountry] = useState("India");
    const [country, setCountry] = useState("");

    // useEffect(() => {

    //     const getLocation = async () => {
    //         try {
    //             // const res = await fetch("https://ipapi.co/json/");
    //              const res = await fetch("https://ipapi.co/json/", {
    //                 method: "GET",
    //                 headers: {
    //                     Accept: "application/json",
    //                 },
    //             });
    //             const data = await res.json();
    //             const country_name = data.country_name;

    //             // console.log(data.country_name);
    //             const country = data.country_code;

    //             console.log(data.country_name);

    //             if (country === "AE") {
    //                 setPhone("+971-04-3519616");
    //             }
    //             else if (["ZA", "NG", "KE"].includes(country)) {
    //                 setPhone("+234 704 020 0021");
    //             }
    //             else {
    //                 setPhone("+91-124-4807600");
    //             }

    //         } catch (error) {
    //             console.log("Geo fetch failed", error);
    //             setPhone("+91-124-4807600");
    //         }
    //     };

    //     getLocation();

    // }, []);

    // current used
    //     useEffect(() => {

    //     const getLocation = async () => {

    //         try {

    //             const res = await fetch("https://api.country.is/", {
    //                 method: "GET",
    //                 headers: {
    //                     Accept: "application/json",
    //                 },
    //             });

    //             const data = await res.json();

    //             console.log(data);

    //             const country = data.country;

    //             console.log(country);

    //             if (country === "AE" || country === "FR") {
    //                 setPhone("+971-04-3519616");
    //             }
    //             else if (["ZA", "NG", "KE", "SG"].includes(country)) {
    //                 setPhone("+234 704 020 0021");
    //             }
    //             else {
    //                 setPhone("+91-124-4807600");
    //             }

    //         } catch (error) {

    //             console.log("Geo fetch failed", error);

    //             setPhone("+91-124-4807600");

    //         }

    //     };

    //     getLocation();

    // }, []);


    useEffect(() => {
        const getCountry = async () => {
            try {
                const response = await fetch(
                    "https://api.ipinfo.io/lite/me?token=97284bd34c77fb"
                );
                const data = await response.json();

                setCountry({
                    code: data.country, // IN
                });

                // Example phone logic
                if (data.country_code === "AE" || data.country_code === "FR" || data.country_code === "UK" || data.country_code === "GB") {
                    setPhone("+971-04-3519616");
                    setfixcountry("Dubai UAE");
                } else if (["ZA", "NG", "KE", "SG", "ES"].includes(data.country_code)) {
                    setPhone("+234 704 020 0021");
                    setfixcountry("Africa");
                } else {
                    setPhone("+91-124-4807600");
                    setfixcountry("India");
                }
            } catch (error) {
                console.error("IP detection failed:", error);
                setPhone("+91-124-4807600");
                setfixcountry("India");
            }
        };

        const scheduleCountryLookup = () => {
            if (typeof window !== "undefined" && "requestIdleCallback" in window) {
                return window.requestIdleCallback(getCountry, { timeout: 3000 });
            }

            return setTimeout(getCountry, 1200);
        };

        const lookupId = scheduleCountryLookup();

        return () => {
            if (typeof window !== "undefined" && "cancelIdleCallback" in window) {
                window.cancelIdleCallback(lookupId);
                return;
            }

            clearTimeout(lookupId);
        };
    }, []);




    // useEffect(() => {
    //     const getLocation = async () => {

    //         try {

    //             const savedCountry = sessionStorage.getItem("country_code");

    //             if (savedCountry) {

    //                 updatePhone(savedCountry);
    //                 return;

    //             }

    //             const controller = new AbortController();

    //             const timeout = setTimeout(() => {
    //                 controller.abort();
    //             }, 5000);

    //             const res = await fetch("https://api.country.is/", {
    //                 signal: controller.signal,
    //             });

    //             clearTimeout(timeout);

    //             if (!res.ok) {
    //                 throw new Error("Failed to fetch geo data");
    //             }

    //             const data = await res.json();

    //             const country = data.country_code;

    //             console.log("Detected country:", country);

    //             sessionStorage.setItem("country_code", country);

    //             updatePhone(country);

    //         } catch (error) {

    //             console.log("Geo fetch failed", error);

    //             setPhone("+91-124-4807600");

    //         }

    //     };

    //     const updatePhone = (country) => {

    //         if (country === "AE") {
    //             setPhone("+971-04-3519616");
    //         }
    //         else if (["ZA", "NG", "KE"].includes(country)) {
    //             setPhone("+234 704 020 0021");
    //         }
    //         else {
    //             setPhone("+91-124-4807600");
    //         }

    //     };

    //     if (typeof window !== "undefined") {
    //         getLocation();
    //     }

    // }, []);

    if (variant === "footer") {
        return (
            <Link to={`tel:${phone}`}>
                <span>{phone}</span>
            </Link>
        );
    }

    if (variant === "text") {
        return <span>{phone}</span>;
    }


    if (variant === "countryname") {
        return <span>{fixcountry}</span>;
    }

    return (
        <Link to={`tel:${phone}`}>
            <img src="/assets/images/call-icons.webp" alt="Call" className="img-responsive" width="29" height="30" decoding="async" />
            {phone}
        </Link>
    );
};

export default GeoPhone;
